import { WarningSolid } from '@wfp/icons-react';
import type { FC } from 'react';
import React from 'react';

interface Props {
  limit: number;
  remaining: number;
  exhausted: boolean;
}

const AiQuotaNotice: FC<Props> = ({ limit, remaining, exhausted }) => (
  <div
    className={`ai-contextual-hint ai-quota-notice ${
      exhausted ? 'ai-quota-notice-exhausted' : 'ai-quota-notice-low'
    }`}
    role="status"
    data-test-id="ai-quota-notice"
  >
    <WarningSolid width="14" height="14" description="" />
    {exhausted ? (
      <span>You have reached your daily AI request limit</span>
    ) : (
      <>
        <span>You are running low on AI requests today</span>
        <span className="ai-quota-count">
          <strong>
            {limit - remaining}/{limit}
          </strong>{' '}
          requests used
        </span>
        <div
          className="ai-quota-meter"
          role="progressbar"
          aria-label="AI requests used"
          aria-valuemin={0}
          aria-valuemax={limit}
          aria-valuenow={limit - remaining}
        >
          <div
            className="ai-quota-meter-fill"
            style={{ width: `${((limit - remaining) / limit) * 100}%` }}
          />
        </div>
      </>
    )}
  </div>
);

export default AiQuotaNotice;
